/**
 * avvisiTestata.js — che cosa dice la testata della cartella sopra le
 * linguette: le allergie attive e, dal 3/11/2026 (Alex, migration 356), le
 * risposte «sì» a «Patologie cutanee» ed «Herpes».
 *
 * UNA FUNZIONE SOLA, letta dai due stili della cartella (PazienteDetail e
 * PazienteDetailConsole). Fino a quel giorno ognuno filtrava le allergie per
 * conto suo: due copie della stessa regola divergono al primo ritocco, e qui
 * una copia sbagliata e' un avviso clinico che non compare.
 *
 * Riceve la risposta di GET /api/anamnesi-voci/paziente/:id (`data`: voci e
 * risposte) e restituisce:
 *   - allergie:  le voci di allergia attive;
 *   - risposte:  un avviso per ogni domanda con risposta «sì», col titolo e il
 *                testo (vuoto se non c'e'): «Patologie cutanee: <testo>»;
 *                col «no» o senza risposta («non indicato») niente;
 *   - risposteNonLette: true se il server non e' riuscito a leggerle
 *                (`risposte: null`), o se la risposta non le porta affatto
 *                (un backend di prima): la testata lo dice, non tace.
 *
 * REGISTRARE, NON GIUDICARE (MDR): cio' che e' scritto, nella stessa forma
 * delle allergie. Nessuna soglia, nessun colore suo.
 */

/* L'ordine e i nomi a schermo: lo stesso elenco del server
   (services/anamnesiRisposte.js, DOMANDE) e del CHECK della 356. */
export const DOMANDE_SI_NO = [
    { domanda: 'patologie_cutanee', titolo: 'Patologie cutanee' },
    { domanda: 'herpes', titolo: 'Herpes' },
];

export function avvisiDellaTestata(dati) {
    const voci = Array.isArray(dati?.voci) ? dati.voci : [];
    const allergie = voci.filter((v) => v.sezione === 'allergie' && v.stato === 'attiva');
    const lette = Array.isArray(dati?.risposte) ? dati.risposte : null;
    const risposte = (lette || [])
        .filter((r) => r && r.risposta === 'si')
        .map((r) => {
            const d = DOMANDE_SI_NO.find((x) => x.domanda === r.domanda);
            return d ? { chiave: d.domanda, titolo: d.titolo, testo: String(r.testo || '').trim() } : null;
        })
        .filter(Boolean)
        .sort((a, b) => DOMANDE_SI_NO.findIndex((x) => x.domanda === a.chiave)
                      - DOMANDE_SI_NO.findIndex((x) => x.domanda === b.chiave));
    return { allergie, risposte, risposteNonLette: lette === null };
}

/* Il testo di un avviso come si legge: «Herpes: <testo>», o il solo titolo. */
export function testoDellAvviso(a) {
    return a && a.testo ? `${a.titolo}: ${a.testo}` : String(a?.titolo || '');
}

/* QUANTI AVVISI IN RIGA nella testata dello stile nuovo, dopo le allergie
   (NO del beta del 3/11/2026, scenario 2603: con l'Herpes accanto
   all'allergia la testa a 1024x768 passava il terzo della finestra). Le
   risposte e gli avvisi delle schede ne mostrano al piu' tanti; gli altri
   stanno nel segno «+N». Con allergie, Herpes e Patologie cutanee i due si'
   restano in vista tutti e due. */
export const AVVISI_IN_RIGA = 2;

export function dividiAvvisi(elenco, quanti = AVVISI_IN_RIGA) {
    const tutti = Array.isArray(elenco) ? elenco : [];
    const n = Math.max(0, Number.isInteger(quanti) ? quanti : AVVISI_IN_RIGA);
    return { inRiga: tutti.slice(0, n), altri: tutti.slice(n) };
}
